import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Grid, makeStyles, Typography } from '@material-ui/core'

import { usePermissions } from '../../../hooks/usePermission'
import colors from '../../../assets/colors'
import TabNav from '../../../components/ui/TabNav'

import UploadDocModel from './UploadDocModel'
import { Configs } from './Config'
import { VisitChecklist } from './VisitChecklist'

const useStyles = makeStyles({
  rowMessage: {
    padding: '4px 0',
    color: colors.textPrimary,
    fontSize: '14px',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    height: 'auto',
    fontWeight: 'normal',
  },
})

const Settings = () => {
  const [value, setValue] = useState(10)

  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canRead, canUpdate } = usePermissions()
  const styles = useStyles()

  const canReadChecklist = canRead('checklist-visita', permissionUser)

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Typography
          variant="h4"
          style={{ fontSize: '20px', color: colors.primary }}
        >
          Configurações
        </Typography>
      </Grid>

      <Grid item xs="12" className={styles.rowMessage}>
        <Grid container>
          <Grid item xs={12} className={styles.message}>
            Gerencie as configurações da sua lavanderia
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <TabNav
          value={value}
          onChange={setValue}
          tabs={[
            { label: 'Sistema', value: 10 },
            { label: 'Itens Coletados', value: 20 },
            { label: 'Modelo Orçamento', value: 30 },
            ...(canReadChecklist
              ? [{ label: 'Checklist da Visita', value: 40 }]
              : []),
          ]}
        />
      </Grid>

      {value == 10 && (
        <Grid item xs={12} style={{ marginTop: '1em' }}>
          <Configs />
        </Grid>
      )}

      {value == 20 && (
        <Grid item xs={12} style={{ marginTop: '1em' }}>
          <Configs collectedItems />
        </Grid>
      )}

      {value == 30 && (
        <Grid item xs={12}>
          {canUpdate('configuracoes', permissionUser) && <UploadDocModel />}
        </Grid>
      )}

      {value == 40 && canReadChecklist && (
        <Grid item xs={12} style={{ marginTop: '1em' }}>
          <VisitChecklist />
        </Grid>
      )}
    </Grid>
  )
}

export default Settings
